import styled from "@emotion/styled";
import { Colors, FontWeight } from "@snapchat/snap-design-system";

export const MailToLinkWrapper = styled.a`
    cursor: pointer;
    font-weight: ${FontWeight.NORMAL};
    color: ${Colors.Blue.V100};
    text-decoration: none;
`;
